import { Component } from '@angular/core';

@Component({
    selector: 'app-text-img-1',
    templateUrl: './text-img-1.component.html',
    styleUrls: ['./text-img-1.component.scss']
})
export class TextImg1Component {}
